import { API } from "../../../helpers/API/amplifyApi";
import { validateCrashingShifts } from "../../punonjesit/EmployeeView/Payment/EmployeeShifts/utils/apiHelpers";
import dayjsTZ from "../../../utils/dayjs";
import { message } from "antd";
import {
  buildClockingEmployeeSnapshot,
  resolveEmployeeForSnapshot,
} from "../../../utils/clockingEmployeeSnapshot";
import { resolveTeamTimezone } from "../../../utils/timezone/teamTimezone";
import { dayCalculateFactory } from "../PaySub/employeeCalc/dayCalculateFactory";

export const matchDepartamentWithEmployee = (departmentId, departments) => {
  let res = departments.filter((el) => el.departmentId === departmentId);
  if (res.length > 0) {
    return res[0].departmentName;
  } else {
    return null;
  }
};

const LEAVE_TYPES_BLOCKING = new Set(["Pushime", "Leje Ditore"]);

/**
 * Block clock-in when the employee has an approved leave covering that day.
 * Uses in-memory employeeRequests + employee.userSub (no extra GET).
 * Status in EU data is "Aprovuar" (legacy code used "APPROVED").
 */
export const hasApprovedLeaveOnDay = (
  shiftData,
  employeeId,
  employeeRequests,
  employeeOrEmployees
) => {
  if (!Array.isArray(employeeRequests) || !employeeId) return false;
  const employee = resolveEmployeeForSnapshot(
    employeeOrEmployees,
    employeeId
  );
  const userSub = employee?.userSub;
  if (!userSub) return false;

  const day = dayjsTZ(shiftData?.clockInDate).format("DD/MM/YYYY");
  return employeeRequests.some((el) => {
    if (el?.userSub !== userSub) return false;
    if (el?.requestStatus !== "Aprovuar") return false;
    if (el?.requestType && !LEAVE_TYPES_BLOCKING.has(el.requestType)) {
      return false;
    }
    if (!Array.isArray(el?.requestPeriod)) return false;
    return el.requestPeriod.some(
      (period) => dayjsTZ(period).format("DD/MM/YYYY") === day
    );
  });
};

/**
 * @param {object} shiftData
 * @param {string} employeeId
 * @param {Array} employeeRequests
 * @param {object|Array} [employeeOrEmployees] employee record or list for snapshot
 */
export const createNewShiftByAdmin = async (
  shiftData,
  employeeId,
  employeeRequests,
  employeeOrEmployees,
  programFields
) => {
  if (
    hasApprovedLeaveOnDay(
      shiftData,
      employeeId,
      employeeRequests,
      employeeOrEmployees
    )
  ) {
    message.error(
      "Ju nuk mund të filloni turnin — ka një leje të aprovuar për këtë ditë."
    );
    return Promise.reject(["approved_leave", shiftData]);
  }

  let valid = await validateCrashingShifts(shiftData, employeeId, null);

  console.log("valid", valid);

  if (valid.value === true) {
    const employee = resolveEmployeeForSnapshot(
      employeeOrEmployees,
      employeeId
    );
    const employeeSnapshot = buildClockingEmployeeSnapshot(employee);
    const timezone =
      typeof shiftData?.timezone === "string" && shiftData.timezone.trim()
        ? shiftData.timezone.trim()
        : resolveTeamTimezone(employee?.employeeTeam, programFields);

    const resolvedEmployeeId = shiftData?.employeeId || employeeId;
    const clockInMs = dayjsTZ(shiftData.clockInDate).valueOf();
    const hasClockOut =
      shiftData?.clockOutDate != null && shiftData.clockOutDate !== "";
    const clockOutMs = hasClockOut
      ? dayjsTZ(shiftData.clockOutDate).valueOf()
      : null;

    // Closed admin-created shifts must persist totalities (same as edit/approve).
    let totalities = shiftData?.totalities;
    const needsTotalities =
      hasClockOut &&
      (!totalities ||
        typeof totalities !== "object" ||
        !Object.keys(totalities).length);
    if (needsTotalities) {
      totalities =
        (await dayCalculateFactory({
          ...shiftData,
          employeeId: resolvedEmployeeId,
          clockInDate: clockInMs,
          clockOutDate: clockOutMs,
        })) || {};
    }

    return API.post("clocking", `/clocking`, {
      body: {
        clockingCategory: "midnightReset",
        ...employeeSnapshot,
        ...shiftData,
        timezone,
        employeeId: resolvedEmployeeId,
        clockInDate: clockInMs,
        ...(hasClockOut ? { clockOutDate: clockOutMs } : {}),
        ...(totalities ? { totalities } : {}),
      },
    }).then((res) => res);
  } else {
    return Promise.reject([valid.crashShift, shiftData]);
  }
};
